import React from 'react'

export default function NumberOfLogsFormStyle() {
    return (
        <React.Fragment>
            <style jsx='true'>
            {`
                .input-wrapper label { margin-bottom: 5px; }
                .input-wrapper input {
                    padding: 10px;
                    font-size: 1rem;
                }
                .input-wrapper {
                    display: flex;
                    flex-direction: column;
                }
                .form-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    flex: 2;
                    padding: 10px;
                    height: 100%;
                }
                .action-buttons-container {
                    display: flex;
                    justify-content: flex-end;
                }
            `}
            </style>
        </React.Fragment>
    )
}